import DataTable from 'datatables.net-dt/js/dataTables.dataTables.min.js';
import buttonsDataTable from 'datatables.net-buttons-dt/js/buttons.dataTables.min.js';
import responsiveDataTable from 'datatables.net-responsive-dt/js/responsive.dataTables.min.js';
jQuery('#example').DataTable({
  responsive: true,
  dom: 'Bfrtip',
  buttons: ['colvis']
});